<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('File') }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div v-if="upload && upload.file">
              {{ $t('Filename') }}: {{ upload.file.originalName }}
            </div>
          </v-col>
          <v-col cols="12">
            <v-text-field :label="$t('Description')" v-model="description"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="tags"
              :items="fileTags"
              filled
              chips
              label="Tags"
              item-text="name"
              item-value="id"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  :color="data.item.color"
                  text-color="white"
                  @click="data.select"
                  @click:close="removeTag(data.item)"
                >
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-content class="ma-0">
                  <v-list-item-title>
                    <v-chip
                      v-html="data.item.name"
                      class="ma-0"
                      :color="data.item.color"
                      text-color="white"
                    />
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          text
          @click="close"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="doConfirm"
        >
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CourseUploadEditDialog',
  props: {
    allTags: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showDialog: false,
      resolve: null,
      upload: null,
      description: '',
      tags: [],
    }
  },
  computed: {
    fileTags() {
      return (this.allTags || []).filter(tag => tag && tag.type === 'file')
    }
  },
  methods: {
    show(upload) {
      this.upload = upload
      this.description = upload.description || ''
      this.tags = (upload.tags || []).map(tag => typeof tag === 'object' ? tag.id : tag)
      this.showDialog = true
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    doConfirm() {
      this.resolve({
        description: this.description,
        tags: this.tags,
      })
      this.close()
    },
    close() {
      this.showDialog = false
      this.upload = null
    },
    removeTag(item) {
      const index = this.tags.indexOf(item.id)
      if (index >= 0) this.tags.splice(index, 1)
    },
  },
}
</script>
